import React from "react";
import { LandingNav, Hero, LiveStatsBar } from "../components/landing/LandingTop";
import { Manifesto, MemberMap } from "../components/landing/LandingMid";
import PhoneShowcase from "../components/landing/PhoneShowcase";
import { FeatureShowcase } from "../components/landing/FeatureShowcase";
import { PregnancyBand } from "../components/landing/PregnancyBand";
import { TrimesterTimeline } from "../components/landing/TrimesterTimeline";
import { LumiDemo } from "../components/landing/LumiDemo";
import { CoupleStories } from "../components/landing/CoupleStories";
import { TrustBand } from "../components/landing/TrustBand";
import { CoachPreview } from "../components/landing/CoachPreview";
import { PlanQuiz } from "../components/landing/PlanQuiz";
import { Reveal } from "../components/landing/Reveal";
import { WovenBand } from "../components/landing/WovenBand";
import { SocialProof } from "../components/landing/SocialProof";
import { useLenis, ScrollProgress, StickyCTA, Divider } from "../components/landing/Immersion";
import {
  FamilyPlan,
  Pricing,
  FinalCTA,
  Footer,
} from "../components/landing/LandingBottom";

export default function Landing({ onNavigate }) {
  useLenis();
  const goJoin = () => onNavigate && onNavigate("signup");
  const goLogin = () => onNavigate && onNavigate("login");
  return (
    <div className="min-h-screen bg-ink text-mist">
      <ScrollProgress />
      <LandingNav onJoin={goJoin} onLogin={goLogin} />
      <main>
        <Hero onJoin={goJoin} />
        <LiveStatsBar />
        <Reveal><Manifesto /></Reveal>
        <WovenBand />
        <Reveal><MemberMap /></Reveal>
        <Reveal><CoachPreview onJoin={goJoin} /></Reveal>
        <Reveal><PhoneShowcase onJoin={goJoin} /></Reveal>
        <Reveal><FeatureShowcase onJoin={goJoin} /></Reveal>
        <Divider className="my-6" />
        <PregnancyBand onJoin={goJoin} />
        <TrimesterTimeline />
        <Reveal><LumiDemo onJoin={goJoin} /></Reveal>
        <Reveal><CoupleStories /></Reveal>
        <Reveal><PlanQuiz onJoin={goJoin} /></Reveal>
        <Divider className="my-6" />
        <Reveal><FamilyPlan onJoin={goJoin} /></Reveal>
        <Reveal><Pricing onJoin={goJoin} /></Reveal>
        <Reveal><TrustBand /></Reveal>
        <Reveal><SocialProof /></Reveal>
        <Divider className="my-6" />
        <Reveal><FinalCTA onJoin={goJoin} /></Reveal>
      </main>
      <Footer onNavigate={onNavigate} />
      <StickyCTA onJoin={goJoin} />
    </div>
  );
}
